module.exports = "<app-resolve promise=\"$ctrl.promise\">\r\n\t<div class=\"ui-grid\"\r\n\t\tng-if=\"$ctrl.grid\"\r\n\t\tag-grid=\"$ctrl.grid\">\r\n\t</div>\r\n</app-resolve>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/finanzas/components/posicionbancaria/estatus/grid/template.html
// module id = 2796
// module chunks = 0